import { render, staticRenderFns } from "./WebContents.vue?vue&type=template&id=8a534738&scoped=true"
import script from "./WebContents.vue?vue&type=script&lang=js"
export * from "./WebContents.vue?vue&type=script&lang=js"
import style0 from "./WebContents.vue?vue&type=style&index=0&id=8a534738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a534738",
  null
  
)

export default component.exports